<template>
  <div class="clearfix search">
    <input placeholder="简单描述你要搜索的问题，如：“忘记密码怎么办”"
      v-model="query"
      class="pull-left"
      ref="search"
      @keyup.enter="search"
    />
    <a class="white pointer text-center btn pull-right" @click="search">搜索</a>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
export default {
  name: 'Search',
  data() {
    return {
      query: '',
      searchInput: null,
    };
  },
  watch: {
    $route(to) {
      const {
        params: {
          question,
          detailId,
        },
      } = to;

      if (!question && !detailId) {
        this.query = '';
      }
    },
  },
  mounted() {
    const {
      params: {
        question,
      },
    } = this.$route;
    this.query = question || '';

    const searchInput = this.$refs.search;
    this.searchInput = searchInput;
    searchInput.focus();
  },
  methods: {
    search() {
      const { query } = this;
      if (!query) {
        this.searchInput.focus();
      } else {
        this.$router.push(`/search/${query}`);
      }
    },
  },
};
</script>
